<template>
  <q-icon
    class="cursor-pointer q-pb-xs"
    dense
    size="xs"
    name="help"
    @click="onclickHelp"
  >
    <q-tooltip class="bg-primary">help</q-tooltip>
  </q-icon>
</template>
<script>
export default {
  name: "HelpComponent",
  props: {
    helpUrl: { type: String },
  },
  setup(props) {
    const onclickHelp = () => {
      window.open(props.helpUrl, "_blank");
    };
    return { onclickHelp };
  },
};
</script>
